<template>
    <div>
        <div class="container">
            <div class="handle-box">
                <el-date-picker
                    class="mr10"
                    v-model="date_value"
                    type="daterange"
                    start-placeholder="开始日期"
                    end-placeholder="截止日期"
                    value-format="yyyy-MM-dd"
                    @change="dateChange"
                    >
                </el-date-picker>
                <el-select v-model="date_id" class="handle-select" @change="selectStatisticsHandle">
                    <el-option
                      v-for="(child, index) in date_types"
                      :key="index"
                      :label="child.name" :value="child.id"></el-option>
                </el-select>
            </div>
            <div id="order_cavans" style="width: 100%;height:600px;margin-bottom: 20px;" v-loading="order_loading"></div>
            <div class="handle-box">
                <label>订单类型：</label>
                <el-select v-model="order_id" class="handle-select mr10" @change="selectHandle">
                    <el-option
                      v-for="(child, index) in order_types"
                      :key="index"
                      :label="child.name" :value="child.id"></el-option>
                </el-select>
                <label>支付状态：</label>
                <el-select v-model="state_id" class="handle-select mr10" @change="selectHandle">
                    <el-option
                      v-for="(child, index) in order_states"
                      :key="index"
                      :label="child.name" :value="child.id"></el-option>
                </el-select>
                 <label>支付来源：</label>
                <el-select v-model="pay_id" class="handle-select mr10" @change="selectHandle">
                    <el-option
                      v-for="(child, index) in pay_types"
                      :key="index"
                      :label="child.name" :value="child.id"></el-option>
                </el-select>
                <el-input v-model="keyword" placeholder="请输入手机号" class="handle-input mr10"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
                <el-button
                type="primary"
                icon="el-icon-lx-down"
                class="handle-down"
                @click="handleExport"
                >批量导出</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                v-loading="loading"
            >
                <el-table-column label="序号" align="center" width="50">
                    <template slot-scope="scope">
                        <span>{{scope.$index+1}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="用户名" align="center">
                    <template slot-scope="scope">
                        {{scope.row.user_info.nickname}}
                    </template>
                </el-table-column>
                <el-table-column label="手机号" align="center">
                    <template slot-scope="scope">
                        {{scope.row.user_info.phone}}
                    </template>
                </el-table-column>
                <el-table-column prop="order_id" label="订单ID" align="center"></el-table-column>
                <el-table-column label="订单类型" align="center">
                    <template slot-scope="scope">
                        {{getIdName(order_types, scope.row.order_type)}}
                    </template>
                </el-table-column>
                <el-table-column label="支付状态" align="center">
                    <template slot-scope="scope">
                        {{getIdName(order_states, scope.row.state)}}
                    </template>
                </el-table-column>
                <el-table-column label="支付来源" align="center">
                    <template slot-scope="scope">
                        {{getIdName(pay_types, scope.row.pay_type)}}
                    </template>
                </el-table-column>
                <el-table-column label="现价(元)" align="center">
                    <template slot-scope="scope">
                        {{formatPrice(scope.row.price)}}
                    </template>
                </el-table-column>
                <el-table-column label="原价(元)" align="center">
                    <template slot-scope="scope">
                        {{formatPrice(scope.row.total_amount)}}
                    </template>
                </el-table-column>
                <el-table-column label="下单时间" align="center">
                    <template slot-scope="scope">
                        {{formatDate(scope.row.created_time)}}
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="80" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            @click="handleLook(scope.row)"
                        >详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination" v-if="totalPages > 1">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :current-page="currentPage"
                    :page-size="page_size"
                    :page-count="totalPages"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <el-dialog :visible.sync="lookVisible" width="60%" :close-on-click-modal="false">
            <el-form label-width="160px">
                <el-form-item label="订单ID：">
                    <span class="fc">{{order_info.order_id}}</span>
                </el-form-item>
                <el-form-item label="订单编号：">
                    <span class="fc">{{order_info.out_trade_no}}</span>
                </el-form-item>
                <el-form-item label="订单类型：">
                    <span class="fc">{{getIdName(order_types, order_info.order_type)}}</span>
                </el-form-item>
                <el-form-item label="支付状态：">
                    <span class="fc">{{getIdName(order_states, order_info.state)}}</span>
                </el-form-item>
                <el-form-item label="支付来源：">
                    <span class="fc">{{getIdName(pay_types, order_info.pay_type)}}</span>
                </el-form-item>
                <el-form-item label="现价(元)：">
                    <span class="fc">{{formatPrice(order_info.price)}}</span>
                </el-form-item>
                <el-form-item label="原价(元)：">
                    <span class="fc">{{formatPrice(order_info.total_amount)}}</span>
                </el-form-item>
                <el-form-item label="下单时间：">
                    <span class="fc">{{formatDate(order_info.created_time)}}</span>
                </el-form-item>
                <el-form-item label="医生：" v-if="diagnosis_info.doctor">
                    <span class="fc">{{diagnosis_info.doctor.name}}</span>
                </el-form-item>
                <el-form-item label="患者：" v-if="diagnosis_info.patient">
                    <span class="fc">{{diagnosis_info.patient.name}}</span>
                </el-form-item>
                <el-form-item label="问诊状态：" v-if="diagnosis_info.diagnosis_type !== undefined">
                    <span class="fc">{{getIdName(diagnosis_types, diagnosis_info.diagnosis_type)}}</span>
                </el-form-item>
                <el-form-item label="会员等级：" v-if="vip_info.level">
                    <span class="fc">{{vip_info.level}}</span>
                </el-form-item>
                <el-form-item label="会员文案：" v-if="vip_info.detail">
                    <span class="fc">{{vip_info.detail}}</span>
                </el-form-item>
                <el-form-item label="会员天数：" v-if="vip_info.day_count">
                    <span class="fc">{{vip_info.day_count}}</span>
                </el-form-item>
                <el-form-item label="问诊折扣：" v-if="vip_info.service_discount">
                    <span class="fc">{{formatPrice(vip_info.service_discount)}}折</span>
                </el-form-item>
                <el-form-item label="购药折扣：" v-if="vip_info.drug_discount">
                    <span class="fc">{{formatPrice(vip_info.drug_discount)}}折</span>
                </el-form-item>
                <el-form-item label="发送方：" v-if="patient_info.name">
                    <span class="fc">{{patient_info.name}}</span>
                </el-form-item>
                <el-form-item label="接收方：" v-if="doctor_info.name">
                    <span class="fc">{{doctor_info.name}}</span>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer self-dialog-footer">
                <el-button type="primary" @click="closeLook">关 闭</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
import echarts from "echarts";
import {_} from 'vue-underscore';
const { export_json_to_excel } = require("../../../utils/Export2Excel.js");
import http from '../../../api/pontusApiConfig'
export default {
    name: 'prescriptionlist',
    data() {
        return {
            date_value: [],
            keyword: '',
            order_types: [
                {"name": "全部", "id": ''},
                {"name": "问诊", "id": 'service'},
                {"name": "会员", "id": 'vip'},
                {"name": "送心意", "id": 'reward'},
                {"name": "购药", "id": 'prescription'}
            ],
            order_id: '',
            order_states: [
                {"name": "全部", "id": ''},
                {"name": "失败", "id": -1},
                {"name": "未支付", "id": 0},
                {"name": "成功", "id": 1},
                {"name": "超时", "id": -2},
                {"name": "退款", "id": -3},
                {"name": "失效", "id": -4}
            ],
            state_id: '',
            pay_types: [
                {"name": "全部", "id": ''},
                {"name": "支付宝APP", "id": 'ali_app'},
                {"name": "支付宝页面", "id": 'ali_page'},
                {"name": "支付宝手机", "id": 'ali_wap'},
                {"name": "微信页面", "id": 'wx_h5_wap'},
                {"name": "微信浏览器", "id": 'wx_js'},
                {"name": "微信APP", "id": 'wx_app'},
                {"name": "微信小程序", "id": 'wx_mini'}
            ],
            pay_id: '',
            start_time: '',
            end_time: '',
            tableData: [],
            currentPage: 1,
            totalPages: 1,
            page_size: 10,
            pageTotal: 10,
            loading: false,
            lookVisible: false,
            order_info: {},
            diagnosis_info: {},
            vip_info: {},
            doctor_info: {},
            patient_info: {},
            diagnosis_types:[
                {"name": "已咨询", "id": 0},
                {"name": "填写健康档案", "id": 1},
                {"name": "填写病症信息", "id": 2},
                {"name": "进入图文对话", "id": 3}
            ],
            diagnosis_id: 1,
            date_types: [
                {"name": "按天", "id": 'day'},
                {"name": "按周", "id": 'week'},
                {"name": "按月", "id": 'month'}
            ],
            date_id: 'day',
            order_loading: false,
            serviceStatistics: [],
            vipStatistics: [],
            rewardStatistics: [],
            prescriptionStatistics: [],
            dateStatistics: []
        };
    },
    created() {
        this.date_value.push("2020-01-01");
        this.date_value.push(new Date().Format('YYYY-MM-DD'));
        this.getData();
    },
    mounted() {
        this.getStatisticsData();
    },
    methods: {
        handleExport(){
            let that = this;
            if(that.totalPages === 1){
                let list = []
                that.tableData.forEach((item, index) => {
                    list.push({
                        name: item['user_info']['nickname'],
                        phone: item['user_info']['phone'],
                        order_id: item['addressee'],
                        order_type: that.getIdName(that.order_types, item['order_type']),
                        state: that.getIdName(that.order_states, item['state']),
                        pay_type: that.getIdName(that.pay_types, item['pay_type']),
                        price: that.formatPrice(item['price']),
                        total_amount: that.formatPrice(item['total_amount']),
                        created_time: that.formatDate(item['created_time'])
                    })
                });
                that.export(list);
            }else{
                that.exportList();
            }
        },
        exportList(){
            let that = this;
            let params = {
                page: 1,
                page_size: that.totalPages * that.page_size
            }
            if(that.keyword){
                params["phone"] = that.keyword;
            }
            if(that.order_id){
                params["order_type"] = that.order_id;
            }
            if(that.pay_id){
                params["pay_type"] = that.pay_id;
            }
            if(that.state_id){
                params["order_state"] = that.state_id;
            }
            params["start_time"] = that.date_value[0];
            params["end_time"] = that.date_value[1];
            http.get("/admin/orders",{params: params}).then(function(res) {
                let list = [];
                res.data.data.order_list.forEach((item, index) => {
                    list.push({
                        name: item['user_info']['nickname'],
                        phone: item['user_info']['phone'],
                        order_id: item['addressee'],
                        order_type: that.getIdName(that.order_types, item['order_type']),
                        state: that.getIdName(that.order_states, item['state']),
                        pay_type: that.getIdName(that.pay_types, item['pay_type']),
                        price: that.formatPrice(item['price']),
                        total_amount: that.formatPrice(item['total_amount']),
                        created_time: that.formatDate(item['created_time'])
                    })
                });
                that.export(list);
            });
        },
        export(res){
            let that = this;
            require.ensure([], () => {
                const tHeader = [
                    "用户名",
                    "手机号",
                    "订单ID",
                    "订单类型",
                    "支付状态",
                    "支付来源",
                    "现价(元)",
                    "原价(元)",
                    "下单时间"
                ];
                const filterVal = [
                    "name",
                    "phone",
                    "order_id",
                    "order_type",
                    "state",
                    "pay_type",
                    "price",
                    "total_amount",
                    "created_time"
                ];
                const data = this.formatJson(filterVal, res);
                export_json_to_excel(tHeader, data, "订单列表");
            });
        },
        formatJson(filterVal, jsonData) {
            return jsonData.map((v) => filterVal.map((j) => v[j]));
        },
        drawOrderChart(){
            let that = this;
            let myChart = echarts.init(document.getElementById("order_cavans"));
            let option = {
                title: {
                    text: '订单统计'
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#6a7985'
                        }
                    }
                },
                legend: {
                    data: ['问诊订单', '会员订单', '送心意订单', '购药订单']
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        boundaryGap: false,
                        data: that.dateStatistics
                    }
                ],
                yAxis: [
                    {
                        type: 'value'
                    }
                ],
                series: [
                    {
                        name: '问诊订单',
                        type: 'line',
                        data: that.serviceStatistics
                    },
                    {
                        name: '会员订单',
                        type: 'line',
                        data: that.vipStatistics
                    },
                    {
                        name: '送心意订单',
                        type: 'line',
                        data: that.rewardStatistics
                    },
                    {
                        name: '购药订单',
                        type: 'line',
                        data: that.prescriptionStatistics
                    }
                ]
            };
            myChart.setOption(option);
            window.onresize=function(){
                myChart.resize();
            }
        },
        selectStatisticsHandle(){
            this.getStatisticsData();
        },
        getStatisticsData() {
            let that = this;
            that.order_loading = true;
            let params = {
                type: that.date_id,
                start_time: that.date_value[0],
                end_time: that.date_value[1]
            }
            http.get("/admin/statistics/orders",{params: params}).then(function(res) {
                that.serviceStatistics = [];
                that.vipStatistics = [];
                that.rewardStatistics = [];
                that.prescriptionStatistics = [];
                that.dateStatistics = [];
                res.data.data.forEach((item, index) => {
                    that.serviceStatistics.push(item['service_count']);
                    that.vipStatistics.push(item['vip_count']);
                    that.rewardStatistics.push(item['reward_count']);
                    that.prescriptionStatistics.push(item['prescription_count']);
                    that.dateStatistics.push(item['date']);
                });
                that.drawOrderChart();
                that.order_loading = false;
            });
        },
        formatDate(time){
            return new Date(time*1000).Format('YYYY-MM-DD hh:mm:ss');
        },
        formatPrice(price){
            return price/100;
        },
        getIdName(list, id){
            let item = _.filter(list, function(selector){ return selector.id == id; })[0];
            if(item){
                return item['name'];
            }else{
                return '';
            }
        },
        dateChange(e){
            this.currentPage = 1;
            this.getData();
        },
        getData() {
            let that = this;
            that.loading = true;
            let params = {
                page: that.currentPage,
                page_size: that.page_size
            }
            if(that.keyword){
                params["phone"] = that.keyword;
            }
            if(that.order_id){
                params["order_type"] = that.order_id;
            }
            if(that.pay_id){
                params["pay_type"] = that.pay_id;
            }
            if(that.state_id){
                params["order_state"] = that.state_id;
            }
            params["start_time"] = that.date_value[0];
            params["end_time"] = that.date_value[1];
            http.get("/admin/orders",{params: params}).then(function(res) {
                that.tableData = res.data.data.order_list;
                that.currentPage = parseInt(res.data.data.current_page);
                that.totalPages = res.data.data.total_pages;
                that.loading = false;
            });
        },
        //选择
        selectHandle(){
            this.currentPage = 1;
            this.getData();
        },
        // 触发搜索按钮
        handleSearch() {
            this.currentPage = 1;
            this.getData();
        },
        onInput(){
            this.$forceUpdate();
        },
        handleLook(row){
            let that = this;
            let params = {
                out_trade_no: row.out_trade_no
            }
            http.get("/admin/order/"+row.order_id).then(function(res) {
                let data = res.data.data;
                that.order_info = data.order_info;
                that.diagnosis_info = {};
                that.vip_info = {};
                that.doctor_info = {};
                that.patient_info = {};
                if(data.diagnosis){
                    that.diagnosis_info = data.diagnosis
                }
                if(data.vip_info){
                    that.vip_info = data.vip_info
                }
                if(data.doctor_info){
                    that.doctor_info = data.doctor_info[0];
                    that.patient_info = {
                        name: row.user_info.nickname
                    }
                }
                that.lookVisible = true;
            });
        },
        closeLook(){
            this.lookVisible = false;
        },
        // 分页导航
        handlePageChange(val) {
            this.currentPage = val;
            this.getData();
        }
    }
};
</script>

<style lang="scss" type="text/css" scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 180px;
}
.self-dialog-footer{
    display: block;
    text-align: center;
}
.avatar {
    height: 178px;
    display: block;
    max-width: 100%;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}
.clearfix:after{content:"";display:block;height:0;clear:both;visibility:hidden;}
.fl{float:left;display:inline;}
.fr{float:right;display:inline;}
.medicines-ul{
    margin-top: 5px;
}
.medicines-ul .li,
.select-medicines-ul li{
    list-style-type: none;
}
.medicines-li{
    margin-right: 5px;
    margin-bottom: 5px;
    display: block;
    max-width: 100%;
    height: 30px;
    line-height: 20px;
    box-sizing: border-box;
    color: #333;
    text-align: center;
    font-size: 14px;
    padding: 5px;
    border: 1px solid #eee;
    border-radius: 6px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    cursor: pointer;
}
.select-medicines-ul{
    width: 100%;
    min-height: 200px;
}
.select-medicines-li{
    margin-top: 10px;
    width: 33.333333%;
    box-sizing: border-box;
    padding-left: 25px;
    padding-right: 100px;
    position: relative;
}
.delete-medicine{
    width: 20px;
    height: 20px;
    padding: 3px;
    margin: auto;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
}
.medicine-name{
    display: block;
    width: 100%;
    height: 32px;
    line-height: 32px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
.medicine-input{
    width: 50px;
    height: 32px;
    line-height: 32px;
    display: block;
    text-align: center;
    position: absolute;
    right: 50px;
    top: 0;
}
.medicine-input .el-input__inner{
    text-align: center;
}
.medicine-unit{
    display: block;
    height: 32px;
    line-height: 32px;
    position: absolute;
    right: 30px;
    top: 0;
}
</style>
